import '../App.css';

function Contact() {
  return (
    <div className="App">
      <div class="topnav">
        <a href="/home">Home</a>
        <a href="/rent">Rent</a>
        <a class="active" href="/contact">Contact</a>
        <a href="/about">About</a>
      </div>
      <h1>Contact Us</h1>
      <div class="container-fluid text-center">    
        <div class="row content">
          <div class="col-sm-2 sidenav">
          </div>
          <div class="col-sm-8 text-left"> 
            <h3>Phone</h3>
            <p>209-666-5533</p>
            <p>331-465-9813</p>
            <h3>Email</h3>
            <p>supersonicrental@gmail.com</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Contact;
